<template>
  <div class="enterpriseCode">
    <div class="enterpriseCode_wrap">
      <div class="enterpriseCode_a">
        <div class="enterpriseCode_a_code">企业微信二维码:</div>
        <div>
          <a-upload
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :default-file-list="defaultFileList"
            :customRequest="upload"
          >
            <img v-if="imageUrl" class="code_img" :src="imageUrl" alt="avatar" />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                Upload
              </div>
            </div>
          </a-upload>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {message} from "ant-design-vue";
  import {
    picUpload,
    wechatQrCode
  } from "@/api/storeApi.js";

  export default {
    name: "enterpriseCode",
    data(){
      return {
        imageUrl:''
      }
    },
    mounted() {
      this.loadCode()
    },
    methods:{
      loadCode(){
        wechatQrCode(sessionStorage.getItem('shopId'))
      },
      upload(file) {
        // file是上传的文件
        const file_size = file.file.size;
        if (file_size > this.$file_max_size) {
          message.error("请确保图片大小在2M以内");
          return false;
        }
        const form = new FormData();
        form.append("file", file.file);
        form.append("contractName", file.file.name);
        form.append("description", file.file.name);
        picUpload(form)
          .then((res) => {
            this.imageUrl= res.data;
            file.onSuccess(res, file);
            message.success("上传成功");
          })
          .catch((err) => {
            message.error("请确保图片大小在2M以内");
          });
      },
    }
  }
</script>

<style scoped lang="scss">
  .enterpriseCode{
    box-sizing: border-box;
    width: 100%;
    padding: 32px ;
    .enterpriseCode_wrap{
      box-sizing: border-box;
      padding: 30px;
      width: 100%;
      height: 100vh;
      background-color: #ffffff;
      .enterpriseCode_a{
        display: flex;

        .enterpriseCode_a_code{
          margin-right: 20px;
          font-size: 14px;
          color: #333;
        }
        .code_img{
          width: 150px;
          height: 150px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/systemManagement/enterpriseCode/enterpriseCode.vue